import React, { useRef, useState } from 'react';
// material
import { SelectChangeEvent } from '@mui/material';
import { alpha, useTheme, Theme } from '@mui/material/styles';
import { Select, Box, Divider, MenuItem, Typography, TextField, useMediaQuery } from '@mui/material';
// components
import MIconButton from '../components/@material-extend/MIconButton';
import MenuPopover from '../components/MenuPopover';
import useLocalStorage from '../hooks/useLocalStorage';
import { BackendData } from "../Common/Utils/backendDataParser";
import useLocales from '../hooks/useLocales';

// ----------------------------------------------------------------------

export default function ClientSelectorPopover() {
  const theme = useTheme<Theme>();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { translate } = useLocales();
  const xsDown = useMediaQuery<Theme>((theme) => theme.breakpoints.down('xs'));

  const [clients] = useLocalStorage<BackendData[]>('clientOptions', []);
  const [selectedClient, setSelectedClient] = useLocalStorage<(BackendData | undefined)>('selectedClient', undefined);

  const selectedIndex = clients.findIndex((backendData: BackendData) => backendData.name == selectedClient.name);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClientChange = (event: SelectChangeEvent<any>) => {
    const index = event.target.value as number;
    setSelectedClient(clients[index]);
    handleClose();
    window.location.reload();
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        style={{
          padding: 0,
          width: 140,
          ...xsDown && {
            width: 100,
          },
          height: 44,
          alignItems: 'center',
          marginRight: theme.spacing(2),
          ...open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              backgroundColor: alpha(theme.palette.grey[900], 0.72)
            }
          }
        }}
      >
        <TextField
          id="clientSelector"
          label={translate("clientSelectorPopover." + "ClientName")}
          type="text"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          defaultValue={selectedClient.name}
          InputProps={{ readOnly: true }}
          fullWidth
          size="small"
        />
      </MIconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        style={{ width: 220 }}
      >
        <Box style={{
          marginTop: theme.spacing(1.5),
          marginBottom: theme.spacing(1.5),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
        }}>
          <Typography variant="subtitle1" noWrap>
            {translate("clientSelectorPopover." + "ClientSelector")}
          </Typography>
        </Box>

        <Divider style={{
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
        }} />

        <Box style={{
          marginTop: theme.spacing(1.5),
          marginBottom: theme.spacing(1.5),
          paddingLeft: theme.spacing(2.5),
          paddingRight: theme.spacing(2.5),
        }}>
          <Select labelId="clients-label" id="clients"
            value={selectedIndex}
            fullWidth
            onChange={handleClientChange}>
            {clients.map((client: BackendData, index: number) => (
              <MenuItem key={index} value={index}>{client.name}</MenuItem>
            ))}
          </Select>
        </Box>
      </MenuPopover>
    </>
  );
}
